// extracted by mini-css-extract-plugin
module.exports = {"reviewtabMinWidth":"415px","overflow_anchor_none":"ZMZOFE","AniFadeIn":"_8Zli9V","AniFadeOut":"epzlGC","AniRotate":"_36r8Mt","AniPlaceholderFadeOut":"cZkD8m"};